export default __webpack_public_path__ + "static/media/Vacuum-Category-Banner.4c4c01d3.png";